export default __webpack_public_path__ + "static/media/9_apple_pay.3f4200db.svg";